module.exports = __webpack_public_path__ + "static/media/MasterCard.fe807bce.png";